import { AbstractControl } from '@angular/forms';

  export function moreThanZeroValidator(control: AbstractControl): { [key: string]: boolean } | null {

    if (control.value == 0) {
        return { 'lessOrEqualToZero': true };
    }
    return null;
}
